/* ----------------------------------------------------------------------------
 * Screening form schema (vue-formulate :schema array)
 * Reconstructed from:
 *   - the compiled bundle's FormulateForm field defs (names, types, options)
 *   - the live app's rendered sections (Inclusion/Exclusion/Informed consent)
 *   - the ground-truth stored shape in firestore_backup.json (USZ-BEX-00001):
 *       data.screeningDate, data.inclusions.{informedConsent,over18YearsOld},
 *       data.exclusions.{impairmentPrecludingConsent,pregnancy},
 *       data.informedConsent.{checked,date}, data.studyInclusion
 *
 * Labels marked (verify) should be confirmed against the live app's i18n text.
 * ------------------------------------------------------------------------- */
export default {
  schema: [
    { component: 'h3', class: 'form-section-title', children: 'Screening' },

    {
      type: 'date',
      name: 'screeningDate',
      label: 'Screening date',
      validation: 'required',
      class: 'w-2/5',
    },

    {
      component: 'h3',
      class: 'form-section-title',
      children: 'Inclusion Criteria',
    },
    {
      type: 'group',
      name: 'inclusions',
      children: [
        {
          type: 'checkbox',
          name: 'informedConsent',
          label: 'Informed consent' /* (verify) */,
        },
        {
          type: 'checkbox',
          name: 'over18YearsOld',
          label: '18 years or above',
        },
      ],
    },

    {
      component: 'h3',
      class: 'form-section-title',
      children: 'Exclusion Criteria',
    },
    {
      type: 'group',
      name: 'exclusions',
      children: [
        {
          type: 'checkbox',
          name: 'impairmentPrecludingConsent',
          label: 'Impairment precluding consent' /* (verify) */,
        },
        { type: 'checkbox', name: 'pregnancy', label: 'Pregnancy' },
      ],
    },

    {
      component: 'h3',
      class: 'form-section-title',
      children: 'Informed consent and signature',
    },
    {
      type: 'group',
      name: 'informedConsent',
      children: [
        {
          type: 'checkbox',
          name: 'checked',
          label: 'Informed consent obtained' /* (verify) */,
        },
        { type: 'date', name: 'date', label: 'Date' },
      ],
    },

    {
      component: 'h3',
      class: 'form-section-title',
      children: 'Study inclusion',
    },
    {
      type: 'select',
      name: 'studyInclusion',
      label: 'Study inclusion',
      options: { '': '', yes: 'yes', no: 'no' },
    },
  ],
}
